import {autoserializeAs} from "dcerialize";
import type {IEquatable} from "../../helpers/Equatable";

export class BasicFile implements IEquatable {
  @autoserializeAs(() => String)
  public readonly contentType: string;
  @autoserializeAs(() => String)
  public readonly contents: string; // Base64 encoded string

  public equals(other: this): boolean {
    return this.contentType === other.contentType && this.contents === other.contents;
  }

  public constructor(contentType: string, contents: string) {
    this.contentType = contentType;
    this.contents = contents;
  }

  public static async fromBlob(blob: Readonly<Blob>): Promise<BasicFile> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = function (this: FileReader): void {
        if (this.result === null || typeof this.result !== "string") {
          reject(new Error("FileReader result is null"));
          return;
        }
        // Base64 string starts with "data:[<mediatype>][;base64],"
        const contents = this.result.split(",")[1];
        if (contents === undefined) {
          reject(new Error("FileReader result does not contain base64 data"));
          return;
        }
        return resolve(new BasicFile(blob.type, contents));
      };
      reader.onerror = function (this: FileReader): void {
        reject(new Error(this.error?.message, {cause: this.error}));
      };
      reader.readAsDataURL(blob);
    });
  }

  public static async fromDOMFile(file: Readonly<File>): Promise<NamedFile> {
    return {
      name: file.name,
      file: await BasicFile.fromBlob(file),
    };
  }
}

export interface NamedFile {
  readonly name: string;
  readonly file: Readonly<BasicFile>;
}
